var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading || _vm.loading),expression:"isLoading || loading"}],staticClass:"loader__wrapper"},[_c('div',{staticClass:"backdrop"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader_box"},[_c('span',{staticClass:"loader_item"})])
}]

export { render, staticRenderFns }